<div class="children">
  <div class="children__label" *ngIf="showHeader">
    <label>{{ question.label }}</label>
  </div>
  <div class="input-group ion-margin-vertical" *ngFor="let childAge of childrenAges; let i = index">
    <label class="input-label">Child {{ i + 1 }}</label>

    <input
      [(ngModel)]="childAge.age"
      (blur)="save(childrenAges[i])"
      (keyup.enter)="save(childrenAges[i])"
      class="form-control"
      placeholder="Age of child {{ i + 1 }}"
      required
      name="{{ question.key }}.{{ i }}"
      maxlength="2"
      min="0"
      max="18"
      [class.has-error]="childAge.error"
      [maskito]="mask"
      (input)="onInputChange(childAge, $event)"
      (ngModelChange)="question.error = null" />

    <div class="input-group__options" (click)="removeChild(childAge.age)">
      @if (i > 0) {
        <ion-icon name="close-circle-outline"></ion-icon>
      }
    </div>

    @if (childrenAges[i].error) {
      <div class="invalid-feedback d-block">
        {{ childrenAges[i].error }}
      </div>
    }
  </div>

  @if (childrenAges.length < 10) {
    <ion-button (click)="addChild()">
      <ion-icon name="add-outline"></ion-icon>
      Add another child
    </ion-button>
  }
</div>
